<template>
  <div v-if="services && options.current" class="services-page">
    <services-list
      :services="services"
      :currentServiceId="currentServiceId"
      @setOption="setOption"
      @setCurrentService="setCurrentService"
    />

    <div class="materials">
      <div class="materials__title">{{ $t("services.masterWork") }}</div>
      <div class="materials__box">
        <material-slider
          :params="options.current"
          @openModal="toggleDetailsModal"
        />

        <div class="materials__offtop">
          <p>{{ $t("forms.materialsListPriceInfoExcluded") }}</p>
        </div>

        <div class="materials-saerch">
          <div class="materials-saerch__box">
            <input
              type="text"
              class="materials-saerch__input"
              v-model="searchText"
              @input="searchMaterials"
            />
          </div>
        </div>

        <div class="materials-list">
          <div
            v-for="item in filteredMaterials"
            :key="item.id"
            class="material"
          >
            <div class="material__img">
              <img :src="item.icon.path" alt />
            </div>
            <div class="material__title">{{ item.name.original }}</div>
            <div class="material__price">
              <span>€{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <main-modal
      :show="showDetailsModal"
      :className="'details-modal'"
      @close="toggleDetailsModal"
    >
      <details-modal :service="activeService" @close="toggleDetailsModal" />
    </main-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import materialSlider from "@/components/sliders/material/slider";
import mainModal from "@/components/modals/mainModal";
import detailsModal from "@/components/modals/details/index";
import servicesList from "@/components/lists/services/servicesList";

export default {
  name: "services-page",
  components: {
    materialSlider,
    mainModal,
    detailsModal,
    servicesList,
  },
  data() {
    return {
      currentServiceId: null,
      filteredMaterials: [],
      searchText: null,
      showDetailsModal: false,
      options: {
        data: null,
        current: null,
      },
      activeService: null,
    };
  },
  computed: {
    ...mapGetters({
      services: "services/originalServices",
      materials: "materials/materials",
    }),
  },
  methods: {
    ...mapActions({
      fetch: "services/fetch",
      fetchMaterials: "materials/fetch",
    }),
    setMaterials() {
      this.filteredMaterials = this.materials;

      this.filteredMaterials = this.filteredMaterials.filter((material) => {
        if (this.currentServiceId == null) return material;
        return material.service_id == this.currentServiceId;
      });
    },
    initCurrentService() {
      if (this.services === null) {
        return;
      }

      if (this.services.length === 0) {
        return;
      }

      this.setCurrentService(this.services[0].id);
      this.setCurrentServiceInstance(this.services[0]);
    },
    setCurrentServiceInstance(v) {
      this.activeService = v;
    },
    setCurrentService(v) {
      this.currentServiceId = v;

      const service = this.services.find((item) => item.id === v);
      this.setCurrentServiceInstance(service);
    },
    setOption(slug) {
      this.options.current = this.options.data.filter(
        (item) => item.slug == slug
      )[0];
    },
    searchMaterials(e) {
      this.filteredMaterials = this.materials.filter((material) => {
        if (
          material.name.original
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) != -1
        ) {
          return material;
        }
      });

      if (this.searchText == "") {
        this.setMaterials();
      }
    },
    toggleDetailsModal() {
      if (!this.showDetailsModal) {
        window.scrollTo({
          top: 0,
        });
      }

      this.showDetailsModal = !this.showDetailsModal;
    },
    setSliderParams() {
      if (this.services && this.services.length > 0) {
        this.options.data = this.services;
        this.options.current = this.options.data[0];
      }
    },
  },
  watch: {
    currentServiceId() {
      this.setMaterials();
    },
  },
  async created() {
    await this.fetch();
    await this.fetchMaterials();

    this.setSliderParams();
    this.initCurrentService();
    this.setMaterials();
  },
  mounted() {
    this.$log("menu_services");
    this.$log("menu_materials");
  },
};
</script>

<style lang="scss">
.services-page {
  width: 100%;
  display: flex;
}

.services {
  width: 225.5px;
  margin-right: 24px;

  &__title {
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0.02em;
    color: #0c0c0c;
    margin: 10px 0 16px;
    font-weight: bold;
    height: 24px;
  }

  &__box {
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
  }

  &-items {
    width: 100%;
    padding: 30px 30px 18px 30px;
  }
}

.service {
  &-item {
    width: 100%;
    max-width: 165px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px 10px 20px rgba(155, 205, 130, 0.2);
    transition: all 0.2s ease-in;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: linear-gradient(
          0deg,
          rgba(155, 205, 130, 0.1),
          rgba(155, 205, 130, 0.1)
        ),
        #ffffff;
    }

    &_active {
      background: linear-gradient(
          171deg,
          rgba(194, 194, 194, 0.1),
          rgba(115, 191, 77, 0.1)
        ),
        #32b0592e !important;
    }

    &__icon {
      width: 40px;
      height: 40px;
      display: block;
      margin: 0 auto 8px;
    }

    p {
      font-family: "crossten";
      font-style: normal;
      font-weight: 800;
      font-size: 18px;
      line-height: 22px;
      text-align: center;
      color: #828282;
      user-select: none;
    }
  }
}

.materials {
  width: 100%;
  max-width: 1200px;

  &__offtop {
    margin-top: 16px;
  }

  &__title {
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0.02em;
    color: #0c0c0c;
    margin: 10px 0 16px;
    font-weight: bold;
    height: 24px;
  }

  &__box {
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    min-height: 70vh;
    padding: 32px 30px;
  }

  &-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    overflow-y: auto;
    padding-right: 20px;

    .material {
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
      width: calc(50% - 8px);
      height: 70px;
      display: flex;
      align-items: center;
      padding: 16px;
      margin-bottom: 16px;

      &__img {
        margin-right: 16px;

        img {
          width: 40px;
        }
      }

      &__price {
        display: flex;
        align-items: center;
        line-height: 1;
        margin-left: auto;

        span {
          font-family: "crossten";
          font-weight: 800;
          font-size: 24px;
          color: #f07300;
        }
      }

      &:nth-child(odd) {
        margin-right: 8px;
      }

      &:nth-child(even) {
        margin-left: 8px;
      }
    }
  }
}

.materials-saerch {
  margin: 24px 0;
  padding: 12px 16px;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.06);

  &__box {
    border: 1px solid #e0e0e0;
    width: 100%;
    height: 36px;
    border-radius: 64px;
    display: flex;
    align-items: center;
  }

  &__input {
    width: 100%;
    border-radius: 64px;
    height: 93%;
    outline: none;
    border: none;
    padding-left: 16px;
    color: #4d4d4d;
  }

  &__img {
    width: 22px;
    height: 22px;
    object-fit: contain;
    margin-right: 12px;
  }
}

@media (max-width: 968px) {
  .services-page {
    flex-wrap: wrap;
  }

  .materials {
    margin-top: 14px;
  }

  .services {
    width: 100%;
    flex-wrap: wrap;
    margin-right: 0;

    &-items {
      display: flex;
      flex-wrap: wrap;
    }
  }

  .service {
    &-item {
      max-width: calc(50% - 6px);

      &:nth-child(odd) {
        margin-right: 6px;
      }

      &:nth-child(even) {
        margin-left: 6px;
      }
    }
  }
}

@media (max-width: 768px) {
  .materials__box {
    padding: 24px;
  }

  .materials-list .material {
    height: auto;
    padding: 8px;
  }

  .material__title {
    font-size: 14px;
    word-break: break-word;
  }

  .materials-list .material__img img {
    width: 24px;
  }

  .materials-list .material__price span {
    font-size: 14px;
  }
}

@media (max-width: 568px) {
  .materials__title,
  .services__title {
    font-size: 20px;
  }
}

@media (max-width: 360px) {
  .materials__box {
    padding: 32px 20px;
  }

  .services-page {
    overflow: hidden;
  }

  .services-items {
    padding: 30px 20px;
  }
}
</style>

<style>
.materials-list::-webkit-scrollbar {
  width: 4px;
}

.materials-list::-webkit-scrollbar-track {
  background: #f6f6f6;
}

.materials-list::-webkit-scrollbar-thumb {
  background: #f07300;
}
</style>
